import { faLocationDot, faVideo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RevSelect } from "@revmatics/catalyst";
import { useState } from "react";
import { userRecommendationsOptions } from "../../../../../../../../pages/campaigns/data/campaignData.ts";
import { RecommendationsItemDataType } from "../../../../../../../../stores/types/campaignsTypes.tsx";
import { getPlatformIcon } from "../../../../../../../../helpers/functions/getPlatformIcon.tsx";

type Props = {
  data: RecommendationsItemDataType;
  edit?: boolean;
  handleChange?: (value: string | number | undefined) => void;
};
export const RecommendationItem = ({
  data,
  edit = false,
  handleChange,
}: Props) => {
  const icon = data.icon_class
    ? getPlatformIcon(data.icon_class)
    : data.type === "in_person"
      ? faLocationDot
      : data.type === "online"
        ? faVideo
        : null;
  const [newValue, setNewValue] = useState(data.recommendation);
  return (
    <div
      key={`recommendations-campaign-${data.label}-${data.icon_class}-${data.type}`}
      className={`p-3 border-bottom border-monochrome-100 flex flex-col md:flex-row gap-2 justify-between md:items-center ${edit ? "border-b border-monochrome-100" : ""}`}
    >
      <div className="flex items-center gap-2">
        {icon ? (
          <FontAwesomeIcon
            icon={icon}
            className="text-monochrome-800 text-xl"
            key={`user-recommendations-${data.icon_class}`}
          />
        ) : (
          <span
            className="text-xs text-monochrome-500"
            key={`user-recommendations-${data.icon_class}`}
          >
            {data.icon_class}
          </span>
        )}
        <p className="typography-body-sm text-monochrome-900">
          {data.label}
          {!edit
            ? ` — ${userRecommendationsOptions.find((item) => item.value === data.recommendation)?.label}`
            : ""}
        </p>
      </div>
      {edit && (
        <div className="md:w-[248px]">
          <RevSelect
            name="recommendation"
            label=""
            options={userRecommendationsOptions}
            value={newValue}
            onChange={(value) => {
              setNewValue(value?.toString() || data.recommendation);
              if (handleChange && !Array.isArray(value)) {
                handleChange(value);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};
